module.exports = __webpack_public_path__ + "img/blog7-1-x1.580a5c7c.webp";